// src/pages/JoinRequests.js
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, updateDoc, doc, arrayUnion } from "firebase/firestore";
import { Container, Card, Button } from "react-bootstrap";

export default function JoinRequests() {
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    const querySnapshot = await getDocs(collection(db, "joinRequests"));
    setRequests(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleApprove = async (id, communityId, userId) => {
    await updateDoc(doc(db, "joinRequests", id), { status: "approved" });
    await updateDoc(doc(db, "communities", communityId), {
      members: arrayUnion(userId)
    });
    fetchRequests();
  };

  return (
    <Container className="mt-4">
      <h2>Join Requests</h2>
      {requests.map(req => (
        <Card key={req.id} className="mb-3">
          <Card.Body>
            <Card.Title>{req.userEmail}</Card.Title>
            <Card.Text>Community: {req.communityId}</Card.Text>
            <Card.Text>Status: {req.status}</Card.Text>
            {req.status === "pending" && (
              <Button onClick={() => handleApprove(req.id, req.communityId, req.userId)}>
                Approve
              </Button>
            )}
          </Card.Body>
        </Card>
      ))}
    </Container>
  );
}